<template>
  <!-- Design-system look of the sign-in pages (Auth/*, Layouts/Unauthenticated.vue): the night view
       of Munich full-bleed behind the page, animated (AuthNightSky), the white logo and below it
       the page's dialog in a dark glass card, "Any questions?" at the bottom
       (resources/css/design-system/night-stage.css). Only the frame: every form, link and action
       stays the page's own; the card's own tokens turn them light on dark ([data-ds-scope]). -->
  <!-- The icons are the design system's static SVGs (ICONS), never user data. -->
  <!-- eslint-disable vue/no-v-html -->
  <div class="ds-night" data-test="auth-shell">
    <AuthNightSky />

    <a
      href="#main-content"
      class="bypass-blocks-button absolute z-100 bg-(--ds-action-brand) px-3 py-2 text-sm font-medium whitespace-nowrap text-(--ds-color-white)"
      v-text="$t('wcag.skip_to_main_content')"
    />

    <main
      id="main-content"
      class="flex flex-1 flex-col items-center px-4 pt-8 pb-10"
    >
      <a :href="useRoute('dashboard')" aria-label="AirLST" class="mb-7">
        <img
          :src="Vapor.asset('images/airlst-logo-white.svg')"
          alt="AirLST"
          class="h-12 w-auto drop-shadow-[0_6px_24px_var(--ds-night-stage-card-glow)]"
          data-test="logo-img"
        />
      </a>

      <div
        class="ds-glass w-full px-6 py-9 sm:px-12"
        :class="wide ? 'max-w-[560px]' : 'max-w-[520px]'"
        data-ds-scope
        data-test="auth-shell-card"
      >
        <!-- The language switch, a globe in the card's top right corner. -->
        <div class="absolute top-4 right-4 z-10">
          <SelectLanguage icon dropdown-class="top-[40px]" />
        </div>
        <slot />
      </div>
    </main>

    <p
      class="ds-night-contact flex flex-wrap items-center justify-center gap-1.5 px-4 pb-6 text-(length:--ds-font-size-md) font-medium text-(--ds-night-stage-text-muted)"
      data-test="auth-shell-contact"
    >
      <span
        class="flex size-4 flex-none [&>svg]:size-full"
        aria-hidden="true"
        v-html="ICONS.headset"
      />
      {{ $t('auth.have_questions') }}
      <a
        class="font-medium text-(--ds-night-stage-link) underline-offset-2 hover:underline"
        href="https://www.airlst.com/de/kontakt"
        target="_blank"
        v-text="$t('settings.contact_us')"
      />
    </p>
  </div>
</template>

<script setup>
import AuthNightSky from '@/Components/Auth/AuthNightSky.vue'
import SelectLanguage from '@/Components/Language/SelectLanguage.vue'
import { useRoute } from '@/composables/route'
import { ICONS } from '@/Libraries/design-system-icons'
import Vapor from 'laravel-vapor'

defineProps({
  /** A longer form (sign-up, activation): a slightly wider card. */
  wide: {
    type: Boolean,
    default: false,
  },
})
</script>
